/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'areas';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'area';

/** Singular entity name for `createCrudModel` reducers/notifications. Often equals `FETCH_ROUTE`. */
export const ENTITY_NAME = 'area';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'areas';
